import TermsAndConditionsRenderAlternatingText from '../AlternatingText';
import TermsAndConditionsRenderBulletList from '../BulletList';
import TermsAndConditionsRenderHeading from '../Heading';
import TermsAndConditionsRenderSection from '../Section';
import TermsAndConditionsRenderSignature from '../Signature';
import TermsAndConditionsRenderSpacer from '../Spacer';
import type { PdfComponent } from '../typed';
import TermsAndConditionsRenderWhitespace from '../Whitespace';

export interface TermsAndConditionsRenderComponentProps {
  component: PdfComponent;
}

const TermsAndConditionsRenderComponent: React.FunctionComponent<TermsAndConditionsRenderComponentProps> =
  function ({ component }) {
    if (component.type === 'altText')
      return (
        <TermsAndConditionsRenderAlternatingText
          content={component.content}
          boldFirst={component.boldFirst}
        />
      );
    if (component.type === 'bulletList')
      return (
        <TermsAndConditionsRenderBulletList
          bulletType={component.bulletType}
          content={component.content}
          prefix={component.prefix}
        />
      );
    if (component.type === 'section')
      return (
        <TermsAndConditionsRenderSection
          title={component.title}
          content={component.content}
        />
      );
    if (component.type === 'signature')
      return <TermsAndConditionsRenderSignature {...component} />;
    if (component.type === 'whitespace')
      return <TermsAndConditionsRenderWhitespace height={component.height} />;
    if (component.type === 'spacer')
      return <TermsAndConditionsRenderSpacer margin={component.margin} />;
    if (component.type === 'heading')
      return (
        <TermsAndConditionsRenderHeading
          title={component.title}
          alignment={component.alignment}
        />
      );
    return null;
  };

export default TermsAndConditionsRenderComponent;
